import { useEffect } from 'react';
import { generateMdx } from '../lib/markdown';
import { releaseNotesMarkdown, markReleasesSeen } from '../lib/releaseNotes';

// Renders the bundled RELEASE_NOTES.md. Visiting the page marks the latest
// release as seen, which clears the unseen-updates dot in the header menu.
export default function WhatsNewPage() {
  useEffect(() => { markReleasesSeen(); }, []);

  return (
    <div
      className="max-w-4xl
        [&_h1]:text-2xl [&_h1]:font-semibold [&_h1]:text-graphite [&_h1]:mb-2
        [&_p]:text-sm [&_p]:text-coolslate [&_p]:leading-relaxed [&_p]:mb-5
        [&_table]:w-full [&_table]:border-separate [&_table]:border-spacing-0 [&_table]:text-sm
        [&_th]:text-left [&_th]:font-semibold [&_th]:text-graphite [&_th]:border-b [&_th]:border-softgrey [&_th]:px-3 [&_th]:py-2
        [&_td]:border-b [&_td]:border-softgrey/60 [&_td]:px-3 [&_td]:py-2.5 [&_td]:align-top
        [&_td:first-child]:whitespace-nowrap [&_td:first-child]:text-coolslate
        [&_code]:font-mono [&_code]:text-xs [&_code]:bg-offwhite [&_code]:text-graphite [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded"
      dangerouslySetInnerHTML={{ __html: generateMdx(releaseNotesMarkdown) }}
    />
  );
}
